/**
 * ПОЛНЫЙ ПУТЬ: D:/QR/QR-WEB/dashboard/src/components/Business/BusinessProfile.js
 * ВЕРСИЯ: 1.0
 * ДАТА: 20.11.2025
 * СТАТУС: ✅ PRODUCTION READY
 */

import React, { useState, useEffect } from 'react';
import './BusinessProfile.css';

const BusinessProfile = () => {
  const [activeTab, setActiveTab] = useState('info');
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [apiKeys, setApiKeys] = useState([]);
  const [showNewKeyForm, setShowNewKeyForm] = useState(false);

  const token = localStorage.getItem('authToken');
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    fetchProfile();
    if (activeTab === 'api') fetchApiKeys();
  }, [activeTab, token]);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `https://qr-money.onrender.com/api/business/profile/${userId}`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      const data = await response.json();
      if (data.success) {
        setProfile(data.data);
        setFormData(data.data);
        setError(null);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchApiKeys = async () => {
    try {
      const response = await fetch(
        'https://qr-money.onrender.com/api/business/api-keys',
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      const data = await response.json();
      if (data.success) setApiKeys(data.data);
    } catch (err) {
      console.error('Error fetching API keys:', err);
    }
  };

  const handleSave = async () => {
    try {
      const response = await fetch(
        `https://qr-money.onrender.com/api/business/profile/${userId}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(formData)
        }
      );
      const data = await response.json();
      if (data.success) {
        setProfile(formData);
        setEditing(false);
        alert('✅ Профиль обновлён');
      }
    } catch (err) {
      alert('❌ Ошибка: ' + err.message);
    }
  };

  const generateApiKey = async () => {
    try {
      const response = await fetch(
        'https://qr-money.onrender.com/api/business/api-keys',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ name: 'API Key ' + new Date().toLocaleDateString() })
        }
      );
      const data = await response.json();
      if (data.success) {
        setApiKeys([...apiKeys, data.data]);
        setShowNewKeyForm(false);
        alert('✅ API ключ создан');
      }
    } catch (err) {
      alert('❌ Ошибка: ' + err.message);
    }
  };

  const deleteApiKey = async (keyId) => {
    if (!window.confirm('Удалить этот ключ?')) return;
    try {
      const response = await fetch(
        `https://qr-money.onrender.com/api/business/api-keys/${keyId}`,
        {
          method: 'DELETE',
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );
      const data = await response.json();
      if (data.success) {
        setApiKeys(apiKeys.filter(k => k.id !== keyId));
        alert('✅ Ключ удалён');
      }
    } catch (err) {
      alert('❌ Ошибка: ' + err.message);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  if (loading) return <div className="profile-loading">Загрузка...</div>;
  if (error) return <div className="profile-error">Ошибка: {error}</div>;

  return (
    <div className="business-profile">
      <h1>👤 Профиль компании</h1>

      <div className="tabs">
        <button 
          className={activeTab === 'info' ? 'active' : ''}
          onClick={() => setActiveTab('info')}
        >
          Основное
        </button>
        <button 
          className={activeTab === 'banking' ? 'active' : ''}
          onClick={() => setActiveTab('banking')}
        >
          Реквизиты
        </button>
        <button 
          className={activeTab === 'settings' ? 'active' : ''}
          onClick={() => setActiveTab('settings')}
        >
          Настройки
        </button>
        <button 
          className={activeTab === 'api' ? 'active' : ''}
          onClick={() => setActiveTab('api')}
        >
          API
        </button>
      </div>

      <div className="profile-content">
        {/* ОСНОВНОЕ */}
        {activeTab === 'info' && (
          <div className="tab-section">
            <div className="edit-header">
              <h2>Основная информация</h2>
              {!editing && <button className="edit-btn" onClick={() => setEditing(true)}>✏️ Редактировать</button>}
            </div>

            {!editing ? (
              <div className="profile-view">
                <div className="field">
                  <label>Название компании:</label>
                  <p>{profile?.company_name || 'Не указано'}</p>
                </div>
                <div className="field">
                  <label>Описание:</label>
                  <p>{profile?.description || 'Не указано'}</p>
                </div>
                <div className="field">
                  <label>Сайт:</label>
                  <p>{profile?.website || 'Не указано'}</p>
                </div>
                <div className="field">
                  <label>Телефон:</label>
                  <p>{profile?.phone || 'Не указано'}</p>
                </div>
                <div className="field">
                  <label>Email:</label>
                  <p>{profile?.email || 'Не указано'}</p>
                </div>
              </div>
            ) : (
              <div className="profile-edit">
                <div className="form-group">
                  <label>Название компании:</label>
                  <input 
                    type="text" 
                    name="company_name" 
                    value={formData.company_name || ''}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>Описание:</label>
                  <textarea 
                    name="description" 
                    value={formData.description || ''}
                    onChange={handleInputChange}
                    rows={4}
                  ></textarea>
                </div>
                <div className="form-group">
                  <label>Сайт:</label>
                  <input 
                    type="url" 
                    name="website" 
                    value={formData.website || ''}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>Телефон:</label>
                  <input 
                    type="tel" 
                    name="phone" 
                    value={formData.phone || ''}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-actions">
                  <button className="save-btn" onClick={handleSave}>💾 Сохранить</button>
                  <button className="cancel-btn" onClick={() => {
                    setEditing(false);
                    setFormData(profile);
                  }}>❌ Отмена</button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* РЕКВИЗИТЫ */}
        {activeTab === 'banking' && (
          <div className="tab-section">
            <div className="edit-header">
              <h2>Банковские реквизиты</h2>
              {!editing && <button className="edit-btn" onClick={() => setEditing(true)}>✏️ Редактировать</button>}
            </div>

            {!editing ? (
              <div className="profile-view">
                <div className="field">
                  <label>ИНН:</label>
                  <p>{profile?.inn || 'Не указан'}</p>
                </div>
                <div className="field">
                  <label>Название банка:</label>
                  <p>{profile?.bank_name || 'Не указано'}</p>
                </div>
                <div className="field">
                  <label>IBAN:</label>
                  <p>{profile?.iban || 'Не указан'}</p>
                </div>
                <div className="field">
                  <label>SWIFT:</label>
                  <p>{profile?.swift || 'Не указан'}</p>
                </div>
              </div>
            ) : (
              <div className="profile-edit">
                <div className="form-group">
                  <label>ИНН:</label>
                  <input 
                    type="text" 
                    name="inn" 
                    value={formData.inn || ''}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>Название банка:</label>
                  <input 
                    type="text" 
                    name="bank_name" 
                    value={formData.bank_name || ''}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>IBAN:</label>
                  <input 
                    type="text" 
                    name="iban" 
                    value={formData.iban || ''}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>SWIFT:</label>
                  <input 
                    type="text" 
                    name="swift" 
                    value={formData.swift || ''}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-actions">
                  <button className="save-btn" onClick={handleSave}>💾 Сохранить</button>
                  <button className="cancel-btn" onClick={() => {
                    setEditing(false);
                    setFormData(profile);
                  }}>❌ Отмена</button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* НАСТРОЙКИ */}
        {activeTab === 'settings' && (
          <div className="tab-section">
            <div className="edit-header">
              <h2>Настройки</h2>
              {!editing && <button className="edit-btn" onClick={() => setEditing(true)}>✏️ Редактировать</button>}
            </div>

            {!editing ? (
              <div className="profile-view">
                <div className="field">
                  <label>Email уведомлений:</label>
                  <p>{profile?.notification_email || 'Не указан'}</p>
                </div>
                <div className="field">
                  <label>Язык:</label>
                  <p>{profile?.language || 'Русский'}</p>
                </div>
                <div className="field">
                  <label>Валюта:</label>
                  <p>{profile?.currency || 'USDT'}</p>
                </div>
                <div className="field">
                  <label>Тайм-зона:</label>
                  <p>{profile?.timezone || 'UTC+3'}</p>
                </div>
              </div>
            ) : (
              <div className="profile-edit">
                <div className="form-group">
                  <label>Email уведомлений:</label>
                  <input 
                    type="email" 
                    name="notification_email" 
                    value={formData.notification_email || ''}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>Язык:</label>
                  <select name="language" value={formData.language || 'ru'} onChange={handleInputChange}>
                    <option value="ru">🇷🇺 Русский</option>
                    <option value="en">🇬🇧 English</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Валюта:</label>
                  <select name="currency" value={formData.currency || 'USDT'} onChange={handleInputChange}>
                    <option value="USDT">USDT (TRC-20)</option>
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Тайм-зона:</label>
                  <select name="timezone" value={formData.timezone || 'UTC+3'} onChange={handleInputChange}>
                    <option value="UTC">UTC</option>
                    <option value="UTC+3">UTC+3</option>
                    <option value="UTC+0">UTC+0</option>
                  </select>
                </div>
                <div className="form-actions">
                  <button className="save-btn" onClick={handleSave}>💾 Сохранить</button>
                  <button className="cancel-btn" onClick={() => {
                    setEditing(false);
                    setFormData(profile);
                  }}>❌ Отмена</button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* API КЛЮЧИ */}
        {activeTab === 'api' && (
          <div className="tab-section">
            <div className="edit-header">
              <h2>🔑 API интеграция</h2>
              {!showNewKeyForm && <button className="add-btn" onClick={() => setShowNewKeyForm(true)}>➕ Новый ключ</button>}
            </div>

            {showNewKeyForm && (
              <div className="api-form">
                <button className="generate-btn" onClick={generateApiKey}>🔐 Сгенерировать ключ</button>
                <button className="cancel-btn" onClick={() => setShowNewKeyForm(false)}>❌ Отмена</button>
              </div>
            )}

            <div className="api-keys-list">
              {apiKeys.length === 0 ? (
                <p className="no-keys">Нет API ключей</p>
              ) : (
                apiKeys.map((key) => (
                  <div key={key.id} className="api-key-card">
                    <div className="key-info">
                      <div className="key-name">{key.name || 'API Key'}</div>
                      <div className="key-value">sk_live_...{key.key?.substring(key.key.length - 8)}</div>
                      <div className="key-dates">
                        Создан: {new Date(key.created_at).toLocaleDateString('ru-RU')}
                        {key.last_used && ` | Использован: ${new Date(key.last_used).toLocaleDateString('ru-RU')}`}
                      </div>
                    </div>
                    <button className="delete-key" onClick={() => deleteApiKey(key.id)}>🗑️</button>
                  </div>
                ))
              )}
            </div>

            <div className="api-docs">
              <h3>📚 Документация API</h3>
              <p>Используй эти ключи в заголовке запроса:</p>
              <code>Authorization: Bearer sk_live_xxxx</code>
              <p>Подробнее: <a href="https://qr-money.onrender.com/api-docs" target="_blank" rel="noopener noreferrer">API Docs</a></p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BusinessProfile;


